import styled from 'styled-components'
import { transitions } from 'polished'
import { getLocalizedSrc } from '@elparking/components'

const lightGray40Color = props => props.theme.colors.lightGray40 || 'black'
const grayColor = props => props.theme.colors.gray || 'black'
const borderRadius = props => props.theme.decoration.radius || '5px'
const mediaScreenMobile = props => `@media screen and (max-width: ${props.theme.screens.medium})`

export const CouponPack = styled.div`
    ${transitions('all 1s ease')}

    ${mediaScreenMobile} {
        padding: 0;
        ${transitions('all none')}
    }
    text-align: center;
`

export const CouponPackLayout = styled.div`

    ${mediaScreenMobile} {
        border-radius: 0;
        padding: 50px 20px;
        width: 100%;
        max-width: none;
        margin: 0px;
        padding: 50px 20px;
    }

    &.selected {
        margin: 0px;
        padding: 50px 20px;
    }

    margin: 30px 0;
    padding: 50px 20px 20px 20px;
    border: 1px solid ${lightGray40Color};
    border-radius: ${borderRadius};
    max-width: 275px;
    background: white;
    ${transitions('all 0.5s ease')}

    box-shadow: 0px 2px 4px 0px rgba(${grayColor}, 0.5));
`

export const CouponPackTitle = styled.span`
    font-size: 18px;
    font-weight: 300;
    color: ${grayColor};
    margin-bottom: 20px;
`

export const CouponPackPrice = styled.div`
    font-weight: 500;
    margin-top: 5px;
    font-size: 28px;
    color: ${grayColor};
    margin-bottom: 20px;
`

export const CouponPackSelect = styled.div`
    padding: 20px 0;
    text-align: center;
    font-size: 18px;
    font-weight: 400;
`

export const CouponPackFieldBtn = styled.div`
    position: relative;
`

export const CouponPackBtn = styled.div`
    left: calc(50% - 7em);
    position: absolute;
    width: 14em;
    top: 20px;
`

export const Coupon = styled.div`
    display: inline-block;
    background-image: url('${(props) => getLocalizedSrc('/images/merchants/coupon.svg', props.country, props.flavor, props.excludedFlavors)}');
    height: 140px;
    width: 140px;
    position: relative;
    margin-bottom: 10px;
`

export const CouponPrice = styled.div`
    position: absolute;
    top: 40px;
    left: 0;
    color: ${grayColor};
    width: 100%;
    text-align: center;
`
